module.exports = __webpack_public_path__ + "img/location-singapore-3-hover.e8846c2b.jpg";